import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 4,
  class: "actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Restricted = _resolveComponent("Restricted")
  const _component_FileSkeleton = _resolveComponent("FileSkeleton")
  const _component_Audio = _resolveComponent("Audio")
  const _component_Docfile = _resolveComponent("Docfile")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_Segment = _resolveComponent("Segment")

  return (_openBlock(), _createBlock(_component_Segment, {
    class: _normalizeClass(["ai-file", {pointer: !!$data.file}]),
    onClick: _cache[3] || (_cache[3] = $event => ($options.ext !== 'mp3' && $options.downloadFile()))
  }, {
    default: _withCtx(() => [
      ($props.restricted)
        ? (_openBlock(), _createBlock(_component_Restricted, { key: 0 }))
        : (!$data.file)
          ? (_openBlock(), _createBlock(_component_FileSkeleton, {
              key: 1,
              class: "file-meta"
            }))
          : ($options.ext === 'mp3')
            ? (_openBlock(), _createBlock(_component_Audio, {
                key: 2,
                file: $data.file,
                class: "audio",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, null, 8 /* PROPS */, ["file"]))
            : (_openBlock(), _createBlock(_component_Docfile, {
                key: 3,
                file: $data.file,
                class: "file-meta"
              }, null, 8 /* PROPS */, ["file"])),
      (!$props.restricted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            ($options.can_share)
              ? (_openBlock(), _createBlock(_component_Tooltip, {
                  key: 0,
                  text: "Share"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Icon, {
                      icon: "share-01",
                      hoverable: "",
                      width: "1.8rem",
                      height: "1.8rem",
                      stroke: "var(--gray-600)",
                      "stroke-width": "1",
                      onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.share()), ["stop"]))
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_Tooltip, { text: "Download" }, {
              default: _withCtx(() => [
                _createVNode(_component_Icon, {
                  icon: "download-02",
                  hoverable: "",
                  width: "1.8rem",
                  height: "1.8rem",
                  stroke: "var(--gray-600)",
                  "stroke-width": "1",
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => ($options.downloadFile()), ["stop"]))
                })
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}